export const LIST_MENU_BAR = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Wallet",
    link: "/wallet",
    pathRelation: [
      "/wallet",
      "/wallet-detail/gameCurrency",
      "/wallet-detail/option",
      "/wallet-detail/crypto",
      "/wallet-detail/commission",
      "/withdraw",
    ],
  },
  {
    title: "Assets",
    link: "/asset",
    pathRelation: ["/address-book"],
  },
  {
    title: "Trade & Earn",
    link: "",
    pathRelation: ["/stake", "/stake-for-option", "/stake-for-voting"],
    subMenu: [
      {
        title: "Stake",
        link: "/stake",
        key: "stake",
        icon: () => (
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.85837 2.34615C3.64922 2.34615 1.85836 4.13701 1.85836 6.34618V18.6538C1.85836 20.863 3.64922 22.6538 5.85837 22.6538H18.166C20.3752 22.6538 22.166 20.863 22.166 18.6538V6.34618C22.166 4.13701 20.3752 2.34615 18.166 2.34615H5.85837ZM0.012207 6.34618C0.012207 3.11741 2.62962 0.5 5.85837 0.5H18.166C21.3948 0.5 24.0122 3.11741 24.0122 6.34618V18.6538C24.0122 21.8826 21.3948 24.5 18.166 24.5H5.85837C2.62962 24.5 0.012207 21.8826 0.012207 18.6538V6.34618Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.109 7.77021C15.5084 8.08701 15.5754 8.66766 15.2586 9.0671L10.114 15.5532C9.81557 15.9295 9.27842 16.014 8.87876 15.7477L5.56794 13.5404L1.65167 18.5741C1.33862 18.9764 0.758661 19.0489 0.356295 18.7358C-0.0460703 18.4228 -0.118477 17.8428 0.194572 17.4404L4.63763 11.7297C4.93456 11.348 5.47578 11.2602 5.87817 11.5285L9.19571 13.7402L13.8122 7.91982C14.129 7.52039 14.7097 7.45341 15.109 7.77021Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.2524 8.33714C10.2524 7.82731 10.6657 7.41406 11.1755 7.41406H15.0647C15.5745 7.41406 15.9878 7.82731 15.9878 8.33714V12.2141C15.9878 12.7238 15.5745 13.1371 15.0647 13.1371C14.5549 13.1371 14.1416 12.7238 14.1416 12.2141V9.26022H11.1755C10.6657 9.26022 10.2524 8.8469 10.2524 8.33714Z"
              fill="black"
            />
          </svg>
        ),
      },
      {
        title: "Mall",
        link: "/mall",
        key: "mall",
        icon: () => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
          >
            <path
              d="M24 6.6C24 4.6152 22.3848 3 20.4 3H3.6C1.6152 3 0 4.6152 0 6.6V9.9972C0 11.2608 0.4584 12.4092 1.2 13.2924V23.4C1.2 24.7236 2.2764 25.8 3.6 25.8H8.4H15.6H20.4C21.7236 25.8 22.8 24.7236 22.8 23.4V13.2912C23.5416 12.4092 24 11.2608 24 9.996V6.6ZM21.6 6.6V9.9972C21.6 11.3652 20.5812 12.5316 19.3308 12.5976L19.2 12.6C17.8764 12.6 16.8 11.5236 16.8 10.2V5.4H20.4C21.0624 5.4 21.6 5.9388 21.6 6.6ZM9.6 5.4H14.4V10.2C14.4 11.5236 13.3236 12.6 12 12.6C10.6764 12.6 9.6 11.5236 9.6 10.2V5.4ZM2.4 6.6C2.4 5.9388 2.9376 5.4 3.6 5.4H7.2V10.2C7.2 11.5236 6.1236 12.6 4.8 12.6L4.6692 12.5964C3.4188 12.5316 2.4 11.3652 2.4 9.9972V6.6ZM9.6 23.4V19.8H14.4V23.4H9.6ZM16.8 23.4V19.8C16.8 18.4764 15.7236 17.4 14.4 17.4H9.6C8.2764 17.4 7.2 18.4764 7.2 19.8V23.4H3.6V14.8428C3.9048 14.9232 4.2204 14.976 4.5444 14.9928C6.0816 15.0732 7.4688 14.4276 8.4 13.3716C9.2796 14.37 10.5684 15 12 15C13.4316 15 14.7204 14.37 15.6 13.3716C16.5312 14.4276 17.9208 15.0744 19.4556 14.9928C19.7808 14.976 20.0952 14.9232 20.4 14.8428V23.4H16.8Z"
              fill="url(#paint0_linear_19114_2003)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_19114_2003"
                x1="0"
                y1="14.4008"
                x2="24.0013"
                y2="14.4008"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#000" />
                <stop offset="1" stopColor="#000" />
              </linearGradient>
            </defs>
          </svg>
        ),
      },
      {
        title: "C2C market",
        link: "/market",
        key: "market",
        icon: () => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M4.82004 2.48882C3.63411 2.80757 2.89817 4.04038 3.19817 5.20288C3.40911 5.99976 4.03723 6.63726 4.82942 6.83882C5.06379 6.89976 5.04504 6.90444 4.22942 6.91851C3.39973 6.93726 3.38098 6.94194 3.07161 7.08726C2.30754 7.44819 1.81536 8.22163 1.67004 9.28101C1.64661 9.48726 1.62786 10.1154 1.63723 10.6732C1.65129 11.7888 1.65598 11.8076 1.97473 12.0419C2.10129 12.1404 2.14348 12.1404 5.37786 12.1404C8.61223 12.1404 8.65442 12.1404 8.78098 12.0419C8.85129 11.9904 8.95442 11.8873 9.00598 11.8169C9.09973 11.6951 9.10442 11.6294 9.09973 10.4154C9.09973 9.16382 9.09504 9.13101 8.96848 8.71851C8.72004 7.90757 8.34036 7.41538 7.73098 7.11538L7.37473 6.93726L6.53098 6.91851C5.70129 6.90444 5.68723 6.89976 5.93567 6.83882C7.11223 6.53413 7.85754 5.28726 7.55754 4.13413C7.24348 2.92007 5.99661 2.17007 4.82004 2.48882Z"
              fill="url(#paint0_linear_19114_17881)"
            />
            <path
              d="M10.3228 6.22946C9.88222 6.42634 9.7416 7.02165 10.051 7.38727C10.276 7.64977 10.351 7.66384 11.8135 7.66384C12.8541 7.66384 13.1963 7.6779 13.4166 7.73415C14.4478 8.00602 15.1275 8.90602 15.1275 9.99821V10.3498L14.9213 10.1576C14.5744 9.83884 14.1666 9.83415 13.8572 10.1435C13.665 10.3357 13.5994 10.556 13.651 10.8373C13.6744 10.9873 13.8197 11.156 14.6025 11.9388C15.5963 12.9326 15.6478 12.9654 16.0557 12.8904C16.201 12.867 16.3697 12.7216 17.1525 11.9388C17.9353 11.156 18.0807 10.9873 18.1041 10.8373C18.1557 10.556 18.09 10.3357 17.8978 10.1435C17.5932 9.83415 17.1807 9.83884 16.8385 10.1529L16.6416 10.3357L16.6135 9.80602C16.576 9.0279 16.4025 8.4654 16.0228 7.88884C15.4885 7.07321 14.7807 6.56227 13.7682 6.26696C13.4072 6.16384 10.5385 6.13102 10.3228 6.22946Z"
              fill="url(#paint1_linear_19114_17881)"
            />
            <path
              d="M8.07356 12.9794C7.99856 13.0169 7.53918 13.4435 7.05637 13.9263C6.32043 14.6716 6.17981 14.8404 6.15168 14.9857C6.10012 15.2716 6.16575 15.4919 6.35793 15.6841C6.66262 15.9935 7.07512 15.9888 7.41731 15.6748L7.61418 15.4919L7.64231 16.0216C7.67981 16.7998 7.85325 17.3623 8.23293 17.9388C8.64543 18.5669 9.34387 19.1529 9.96262 19.3826C10.6282 19.6357 10.6892 19.6404 12.3486 19.6404C13.8439 19.6404 13.9095 19.6357 14.0314 19.5419C14.2798 19.3591 14.3548 19.2091 14.3548 18.9138C14.3548 18.6185 14.2798 18.4685 14.0314 18.2857C13.9095 18.1919 13.8251 18.1873 12.3954 18.1638C10.9986 18.1404 10.8673 18.131 10.6423 18.0373C10.2486 17.8779 10.0095 17.7232 9.75168 17.4513C9.33918 17.0107 9.12825 16.4669 9.12825 15.8294V15.4779L9.3345 15.6701C9.68137 15.9888 10.0892 15.9935 10.3986 15.6841C10.5907 15.4919 10.6564 15.2716 10.6048 14.9857C10.5767 14.8404 10.4361 14.6716 9.70012 13.9263C9.21731 13.4435 8.75793 13.0169 8.67356 12.9794C8.48606 12.8998 8.25637 12.8998 8.07356 12.9794Z"
              fill="url(#paint2_linear_19114_17881)"
            />
            <path
              d="M18.32 13.7388C17.1341 14.0576 16.3982 15.2904 16.6982 16.4529C16.9091 17.2498 17.5372 17.8873 18.3294 18.0888C18.5638 18.1498 18.545 18.1544 17.7294 18.1685C16.8997 18.1873 16.881 18.1919 16.5716 18.3373C15.8075 18.6982 15.3154 19.4716 15.17 20.531C15.1466 20.7373 15.1279 21.3654 15.1372 21.9232C15.1513 23.0388 15.156 23.0576 15.4747 23.2919C15.6013 23.3904 15.6435 23.3904 18.8779 23.3904C22.1122 23.3904 22.1544 23.3904 22.281 23.2919C22.3513 23.2404 22.4544 23.1373 22.506 23.0669C22.5997 22.9451 22.6044 22.8794 22.5997 21.6654C22.5997 20.4138 22.595 20.381 22.4685 19.9685C22.22 19.1576 21.8404 18.6654 21.231 18.3654L20.8747 18.1873L20.031 18.1685C19.2013 18.1544 19.1872 18.1498 19.4357 18.0888C20.6122 17.7841 21.3575 16.5373 21.0575 15.3841C20.7435 14.1701 19.4966 13.4201 18.32 13.7388Z"
              fill="url(#paint3_linear_19114_17881)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_19114_17881"
                x1="1.63477"
                y1="7.27754"
                x2="9.10133"
                y2="7.27754"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#000" />
                <stop offset="1" stopColor="#000" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_19114_17881"
                x1="9.88477"
                y1="9.54278"
                x2="18.1214"
                y2="9.54278"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#000" />
                <stop offset="1" stopColor="#000" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_19114_17881"
                x1="6.13477"
                y1="16.2798"
                x2="14.3552"
                y2="16.2798"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#000" />
                <stop offset="1" stopColor="#000" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_19114_17881"
                x1="15.1348"
                y1="18.5275"
                x2="22.6013"
                y2="18.5275"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#000" />
                <stop offset="1" stopColor="#000" />
              </linearGradient>
            </defs>
          </svg>
        ),
      },
    ],
  },
  {
    title: "Help",
    link: "",
    subMenu: [
      {
        title: "Help center",
        link: "/help",
        key: "help",
        icon: () => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="23"
            viewBox="0 0 25 23"
            fill="none"
          >
            <g clipPath="url(#clip0_19036_17233)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7107 21.1316C14.7107 20.3081 14.0381 19.6408 13.2087 19.6408H11.3694C10.9712 19.6408 10.5891 19.7978 10.3074 20.0774C10.0256 20.3571 9.86744 20.7361 9.86744 21.1316C9.86744 21.955 10.5401 22.6224 11.3694 22.6224H13.2087C14.0381 22.6224 14.7107 21.955 14.7107 21.1316ZM3.44656 17.2872C3.6975 17.3064 4.001 17.3173 4.30594 17.2995C4.46825 18.1172 4.87181 18.8755 5.47412 19.4733C6.27369 20.2669 7.35813 20.7128 8.489 20.7128H9.062C9.03662 20.85 9.02369 20.9901 9.02369 21.1316C9.02369 21.2746 9.03662 21.4146 9.0615 21.5503H8.489C7.13425 21.5503 5.83519 21.0162 4.87744 20.0655C4.11331 19.3071 3.61644 18.3329 3.44656 17.2872ZM3.01731 16.3962C2.35131 16.2847 1.73144 15.9704 1.24756 15.49C0.633813 14.8808 0.289062 14.0547 0.289062 13.1932V11.2136C0.289062 10.3524 0.633813 9.52604 1.24756 8.91702C1.86106 8.30781 2.69362 7.96562 3.5615 7.96562H3.77931C4.12744 3.60317 7.80444 0.170776 12.2891 0.170776C16.7737 0.170776 20.4507 3.60317 20.7988 7.96562H21.0166C21.8845 7.96562 22.7171 8.30781 23.3306 8.91702C23.9443 9.52604 24.2891 10.3524 24.2891 11.2136V13.1932C24.2891 14.0547 23.9443 14.8808 23.3306 15.49C22.7171 16.0991 21.8845 16.4414 21.0166 16.4414H20.051C19.6504 16.4414 19.3259 16.1192 19.3259 15.7215V8.64443C19.3259 4.78671 16.1753 1.65967 12.2891 1.65967C8.40281 1.65967 5.25219 4.78671 5.25219 8.64443V15.7215C5.25219 16.0023 5.09031 16.2454 4.85425 16.3641C4.20412 16.5881 3.19606 16.4259 3.01731 16.3962Z"
                fill="url(#paint0_linear_19036_17233)"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_19036_17233"
                x1="0.289062"
                y1="11.3974"
                x2="24.2903"
                y2="11.3974"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#000" />
                <stop offset="1" stopColor="#000" />
              </linearGradient>
              <clipPath id="clip0_19036_17233">
                <rect
                  width="24"
                  height="22.4516"
                  fill="white"
                  transform="translate(0.289062 0.170776)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
      },
      {
        title: "Social media & Community",
        link: "/social",
        key: "social",
        icon: () => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <g clipPath="url(#clip0_19114_2099)">
              <path
                d="M12.2187 0.34934C12.0922 0.372777 11.8062 0.475902 11.5906 0.579027C10.9016 0.916527 10.3953 1.53528 10.2031 2.28528C10.1469 2.51028 10.1328 2.93215 10.1328 4.60559V6.64465L6.56094 6.63059C4.09531 6.62122 2.91406 6.63528 2.74531 6.66809C2.09375 6.80403 1.53125 7.25403 1.23594 7.87278C1.0625 8.2384 1.0625 8.24309 1.04844 8.94622C1.02969 9.62122 1.03438 9.6634 1.12812 9.75715C1.27344 9.90247 1.52187 9.8884 1.64375 9.73372C1.73281 9.62122 1.74219 9.54622 1.74219 9.05403C1.74219 8.60872 1.76094 8.44934 1.84062 8.2384C1.95312 7.93372 2.24844 7.61965 2.57187 7.46028L2.79687 7.34778H6.38281H9.96875L10.2125 7.46028C10.5172 7.59622 10.8406 7.93372 10.9578 8.2384C11.0422 8.4634 11.0469 8.63215 11.0469 11.8947V15.3165L10.4609 15.34C9.94062 15.3587 9.84687 15.3775 9.60781 15.4947C9.26094 15.6634 8.94687 16.015 8.81562 16.3712C8.71719 16.6384 8.69844 16.6618 7.93906 17.2478C7.5125 17.5759 7.14687 17.8525 7.12812 17.8618C7.10937 17.8712 7.08594 17.6462 7.07656 17.365C7.05312 16.5868 7.27812 16.6618 4.89219 16.6431C3.11562 16.6243 2.86719 16.615 2.67031 16.54C2.375 16.4322 2.04687 16.1322 1.89219 15.8368L1.76562 15.5978L1.74219 13.554C1.71875 11.6228 1.71406 11.5009 1.62969 11.4072C1.5125 11.2806 1.25937 11.2759 1.13281 11.4025C1.04375 11.4915 1.03906 11.5572 1.03906 13.5072C1.03906 15.7056 1.04844 15.804 1.33437 16.2868C1.50781 16.5868 1.93437 16.9665 2.27187 17.1259C2.69375 17.3181 3.05 17.3509 4.82656 17.3556H6.38281V18.0728C6.38281 18.8509 6.39687 18.8931 6.65 18.9681C6.79062 19.015 6.84687 18.9775 7.775 18.2603C8.225 17.9134 8.61875 17.6228 8.65625 17.6087C8.7125 17.5853 8.72656 17.8993 8.73594 19.779L8.75 21.9728L8.88125 22.2212C9.05469 22.5493 9.33594 22.8212 9.65937 22.9759C9.92187 23.0978 9.93125 23.0978 11.2016 23.1118L12.4766 23.1259V23.5431C12.4766 23.7728 12.5 24.0118 12.5281 24.0728C12.5844 24.1947 12.7484 24.2931 12.8891 24.2931C12.9312 24.2931 13.3062 24.0306 13.7234 23.7118L14.4734 23.1353L14.8953 23.1118C15.6125 23.079 16.0906 22.7697 16.3812 22.1509C16.5125 21.865 16.5219 21.804 16.5266 21.2837C16.5312 20.7493 16.5266 20.7165 16.4187 20.6322C16.2875 20.5243 16.0953 20.515 15.9641 20.6134C15.875 20.6697 15.8609 20.74 15.8422 21.2087C15.8141 21.7806 15.7672 21.9306 15.5375 22.1462C15.3266 22.3478 15.1016 22.4181 14.6609 22.4181H14.2625L13.7328 22.8165L13.2031 23.2197L13.1891 22.915C13.1797 22.6525 13.1609 22.5962 13.0531 22.5118C12.9359 22.4228 12.8703 22.4181 11.5437 22.4181C10.2922 22.4181 10.1375 22.4087 9.96875 22.329C9.74844 22.2259 9.55156 22.029 9.48125 21.8415C9.44844 21.7525 9.42969 20.8572 9.42969 19.2025C9.42969 16.8353 9.43437 16.6853 9.51875 16.5212C9.62187 16.3243 9.72031 16.2259 9.93125 16.1181C10.0625 16.0525 10.3719 16.0431 12.6172 16.0431C14.8625 16.0431 15.1719 16.0525 15.3031 16.1181C15.5187 16.2259 15.6125 16.3243 15.725 16.5353C15.8187 16.7087 15.8281 16.8118 15.8422 17.7775C15.8609 18.9634 15.8703 18.9962 16.1797 18.9962C16.2969 18.9962 16.3812 18.9634 16.4422 18.8978C16.5266 18.804 16.5312 18.715 16.5266 17.7118C16.5266 16.69 16.5219 16.615 16.4141 16.3478C16.2641 15.9681 15.8797 15.579 15.5094 15.4431C15.2516 15.3447 15.1672 15.34 13.5078 15.34H11.7734V14.4212C11.7734 13.5634 11.7781 13.5025 11.8578 13.5353C12.2094 13.6759 12.5984 13.6993 14.6234 13.6993H16.6953V14.6322V15.5697L16.8172 15.6634C16.8875 15.7197 16.9906 15.7618 17.0469 15.7618C17.1172 15.7618 17.6516 15.3822 18.4859 14.74L19.8125 13.7228L20.6094 13.6947C21.3031 13.6712 21.4531 13.6478 21.7531 13.5447C22.3906 13.3197 22.9344 12.8603 23.2297 12.2931C23.5531 11.6837 23.5437 11.8572 23.5297 6.84153L23.5156 2.33215L23.3797 2.00403C23.0984 1.31965 22.6531 0.841527 22.0156 0.546215C21.575 0.344652 21.2609 0.29309 20.4359 0.29309C19.8031 0.29309 19.7328 0.302465 19.6484 0.38684C19.5219 0.513402 19.5219 0.775902 19.6578 0.902465C19.7516 0.98684 19.8219 0.996215 20.4453 0.996215C21.4484 0.996215 21.8281 1.11809 22.2922 1.59153C22.4141 1.7134 22.5781 1.94778 22.6625 2.11653L22.8125 2.4259V6.99622V11.5665L22.6625 11.8759C22.4937 12.2181 22.1281 12.5978 21.8141 12.7572C21.4484 12.9447 21.125 12.9962 20.3469 12.9962H19.6109L18.5187 13.8353L17.4219 14.6743L17.3984 13.9243C17.375 13.2072 17.3703 13.1697 17.2625 13.0853C17.1594 13.0009 17.0469 12.9962 14.8859 12.9962C12.5516 12.9962 12.2984 12.9775 11.9516 12.804L11.7734 12.715V10.6525C11.7734 9.32122 11.7547 8.50559 11.7219 8.34622C11.6375 7.94309 11.45 7.60559 11.1312 7.27278L10.8312 6.9634L10.8453 4.69465L10.8594 2.4259L11.0047 2.12121C11.1594 1.7884 11.4828 1.43684 11.7875 1.25403C12.2187 1.00559 12.3219 0.996215 15.1812 0.996215C17.7594 0.996215 17.8203 0.996215 17.9141 0.902465C17.9703 0.846215 18.0078 0.747777 18.0078 0.644652C18.0078 0.541527 17.9703 0.44309 17.9141 0.38684C17.8203 0.29309 17.7594 0.29309 15.1391 0.297777C13.6625 0.302465 12.35 0.321215 12.2187 0.34934Z"
                fill="url(#paint0_linear_19114_2099)"
              />
              <path
                d="M17.2109 2.95559C16.9766 3.08215 16.8453 3.29778 16.8125 3.61184C16.7703 4.02903 16.6578 4.42278 16.5125 4.65247C16.4375 4.76965 16.1422 5.13059 15.8516 5.45872C15.3875 5.98372 15.3172 6.04934 15.2562 5.9884C15.2 5.93215 14.9937 5.91809 14.0703 5.91809C12.9687 5.91809 12.95 5.91809 12.8797 6.02122C12.8141 6.11497 12.8047 6.41497 12.8047 8.3884C12.8047 10.5915 12.8094 10.6572 12.8984 10.7462C12.9875 10.8353 13.0531 10.84 14.0844 10.84C15.1156 10.84 15.1859 10.8353 15.2656 10.7462C15.3453 10.6572 15.35 10.6572 15.5187 10.7415C16.0109 10.9947 16.1094 11.004 18.2187 11.004C20.1734 11.004 20.1875 11.004 20.3844 10.8962C20.4969 10.84 20.6422 10.704 20.7125 10.5962L20.8437 10.3993L20.8578 8.52434C20.8672 7.4884 20.8578 6.57434 20.8437 6.48997C20.8062 6.29309 20.5672 6.02122 20.3281 5.9134C20.1687 5.8384 20.0094 5.82434 19.1844 5.82434C18.2937 5.82434 18.2328 5.81965 18.2656 5.73997C18.5047 5.17278 18.5703 4.57747 18.4578 4.04309C18.3641 3.59778 18.1391 3.1384 17.9516 3.00715C17.75 2.86184 17.4219 2.8384 17.2109 2.95559ZM17.6469 3.78997C17.6937 3.87903 17.7547 4.09934 17.7828 4.27747C17.8531 4.69465 17.7875 5.07903 17.5344 5.66497C17.4359 5.90403 17.3516 6.14309 17.3516 6.19934C17.3516 6.2509 17.4031 6.34934 17.4687 6.41028L17.5812 6.52747H18.8187C19.7141 6.52747 20.0656 6.54153 20.1078 6.58372C20.15 6.6259 20.1641 7.09934 20.1641 8.43528C20.1641 10.1603 20.1594 10.2306 20.075 10.2775C19.9531 10.3384 16.7703 10.3384 16.3719 10.2775C16.0578 10.2259 15.7906 10.1087 15.5375 9.91653L15.3828 9.80403V8.4259V7.05247L16.2031 6.11965C16.7375 5.51497 17.0797 5.08372 17.1828 4.88684C17.3656 4.53997 17.4922 4.09934 17.4922 3.8134C17.4922 3.57903 17.5437 3.56965 17.6469 3.78997ZM14.6797 8.37903V10.1368H14.0937H13.5078V8.37903V6.62122H14.0937H14.6797V8.37903Z"
                fill="url(#paint1_linear_19114_2099)"
              />
              <path
                d="M5.75501 9.4759C5.6847 9.5509 5.6097 9.91653 5.44563 10.9197C5.44563 10.929 5.10813 10.9337 4.70032 10.9337C3.98782 10.9337 3.94563 10.9384 3.83313 11.0368C3.66438 11.1915 3.65032 11.3884 3.80501 11.5431C3.88938 11.6275 3.9597 11.6368 4.60188 11.6368H5.30501V11.7634C5.30032 11.8384 5.27688 12.0306 5.24407 12.1993L5.18782 12.504L4.53157 12.5181C3.78626 12.5322 3.71126 12.565 3.71126 12.8556C3.71126 13.1556 3.81438 13.2025 4.48938 13.2259C4.80813 13.2306 5.07063 13.2447 5.07063 13.2493C5.07063 13.2493 5.02845 13.4978 4.97688 13.7931C4.92532 14.0884 4.88313 14.3884 4.88313 14.454C4.88313 14.6134 5.06595 14.7775 5.24407 14.7775C5.47845 14.7775 5.54407 14.6556 5.66126 13.9478C5.7222 13.5915 5.77376 13.2868 5.77376 13.2634C5.77376 13.2447 5.96595 13.2306 6.19563 13.2306C6.4722 13.2306 6.61751 13.2493 6.61751 13.2822C6.61751 13.3103 6.57063 13.5962 6.51907 13.9197C6.42063 14.5056 6.42063 14.5056 6.5097 14.6322C6.63626 14.7962 6.87063 14.8197 7.01595 14.6837C7.10501 14.5993 7.14251 14.4681 7.23157 13.9056L7.33938 13.2306H8.02376C8.74095 13.2306 8.98001 13.1884 9.05501 13.0431C9.12063 12.9212 9.11126 12.7478 9.03626 12.64C8.97532 12.5603 8.89095 12.5462 8.22532 12.5275C7.37688 12.4993 7.45657 12.565 7.55501 11.9743L7.61126 11.6368H8.25345C8.86751 11.6368 8.90501 11.6322 8.99876 11.529C9.1347 11.3837 9.13001 11.1915 8.9847 11.0509C8.87688 10.9384 8.84407 10.9337 8.30501 10.9337C7.95813 10.9337 7.74251 10.915 7.74251 10.8868C7.74251 10.8587 7.7847 10.5728 7.83626 10.2447C7.93001 9.65872 7.93001 9.64465 7.84563 9.52747C7.70032 9.33528 7.35813 9.34465 7.26907 9.54153C7.24563 9.59778 7.17532 9.93059 7.11907 10.2775L7.01126 10.9103L6.58938 10.9243L6.16282 10.9384L6.2472 10.4322C6.3597 9.78059 6.3597 9.56497 6.25188 9.46653C6.1347 9.35872 5.85345 9.3634 5.75501 9.4759ZM6.89876 11.6462C6.89876 11.7212 6.75345 12.4478 6.7347 12.4806C6.72063 12.5087 6.52845 12.5275 6.30813 12.5275C5.86751 12.5275 5.88626 12.5509 5.96126 12.1243C6.05501 11.5853 6.00345 11.6368 6.47688 11.6368C6.71126 11.6368 6.89876 11.6415 6.89876 11.6462Z"
                fill="url(#paint2_linear_19114_2099)"
              />
              <path
                d="M11.3141 17.7119C11.0516 17.8431 10.8922 18.0072 10.7281 18.3119C10.6438 18.4666 10.625 18.5837 10.625 18.9259C10.625 19.3103 10.6391 19.3806 10.7797 19.6619C10.8875 19.8869 11.0234 20.0603 11.2531 20.2712C11.5672 20.5619 12.1719 20.9556 12.4672 21.0681C12.6547 21.1384 12.7766 21.1009 13.2875 20.7916C13.8359 20.4634 14.2672 20.0416 14.4547 19.6619C14.5953 19.3806 14.6094 19.3103 14.6094 18.9259C14.6094 18.5462 14.5953 18.4806 14.4688 18.2509C14.3234 17.9884 14.0563 17.7541 13.775 17.6509C13.5078 17.5525 13.0813 17.5759 12.8375 17.7025L12.6172 17.8103L12.3969 17.7025C12.0828 17.5431 11.6469 17.5478 11.3141 17.7119ZM12.2703 18.5134C12.425 18.6822 12.5047 18.7291 12.6172 18.7291C12.7297 18.7291 12.8094 18.6822 12.9641 18.5134C13.1422 18.3166 13.1891 18.2931 13.3625 18.2931C13.5172 18.2931 13.5922 18.3259 13.7328 18.4525C13.9016 18.6119 13.9063 18.6212 13.9063 18.94C13.9063 19.2306 13.8875 19.2916 13.7656 19.4744C13.5969 19.7087 13.1844 20.0509 12.8516 20.2337L12.6172 20.3603L12.3922 20.2384C12.0594 20.0603 11.6516 19.7275 11.4922 19.5072C11.2438 19.165 11.2484 18.6869 11.4969 18.4337C11.6141 18.3166 11.6797 18.2931 11.8531 18.2931C12.05 18.2931 12.0875 18.3119 12.2703 18.5134Z"
                fill="url(#paint3_linear_19114_2099)"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_19114_2099"
                x1="1.03906"
                y1="12.2923"
                x2="23.5361"
                y2="12.2923"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#000" />
                <stop offset="1" stopColor="#000" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_19114_2099"
                x1="12.8047"
                y1="6.9422"
                x2="20.862"
                y2="6.9422"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#000" />
                <stop offset="1" stopColor="#000" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_19114_2099"
                x1="3.69727"
                y1="12.0828"
                x2="9.09918"
                y2="12.0828"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#000" />
                <stop offset="1" stopColor="#000" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_19114_2099"
                x1="10.625"
                y1="19.3419"
                x2="14.6096"
                y2="19.3419"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#000" />
                <stop offset="1" stopColor="#000" />
              </linearGradient>
              <clipPath id="clip0_19114_2099">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(0.289062 0.293091)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
      },
    ],
  },
];

export const TYPE_WALLET_DETAIL = {
  OPTION: "option",
  CRYPTO: "crypto",
  GAMECURRENCY: "gameCurrency",
  GAMECURRENCYSGT: "gameCurrencySGT",
  COMMISSION: "commission",
  AFFILIATE: "affiliate",
};
export const STAKE_OPTIONS = [
  {
    value: 0,
    label: "{year} Year",
    year: 1,
  },
  {
    value: 1,
    label: "{year} Years",
    year: 1.5,
  },
  {
    value: 2,
    label: "{year} Years",
    year: 2,
  },
  {
    value: 3,
    label: "{year} Years",
    year: 2.5,
  },
];
export const FILTER_PRODUCT_OPTIONS = {
  deposit: [
    {
      label: "SGT",
      value: "SGT",
    },
  ],
  interest: [
    {
      label: "xSGT",
      value: "xSGT",
    },
  ],
  type: [
    {
      label: "Locked Staking",
      value: "Locked Staking",
    },
  ],
  status: [
    {
      label: "Processing",
      value: "Processing",
    },
    {
      label: "Active",
      value: "Active",
    },
    {
      label: "Closed",
      value: "Closed",
    },
    {
      label: "Canceled",
      value: "Canceled",
    },
    {
      label: "Failed",
      value: "Failed",
    },
  ],
};

export const PageIgnoreHeaderMobile = [
  "/stake-detail",
  "/stake-success",
  "/transaction-history",
];

export const StatusSort = {
  ascend: "ascend",
  descend: "descend",
  none: undefined,
};
export const Sort = {
  createdTime_desc: "createdTime_desc",
  createdTime_asc: "createdTime_asc",
  amount_desc: "amount_desc",
  amount_asc: "amount_asc",
  type_desc: "type_desc",
  type_asc: "type_asc",
};
export const SZT_SORT = {
  createdTime_desc: {
    column: "CREATE_TIME",
    type: "DESC",
  },
  createdTime_asc: {
    column: "CREATE_TIME",
    type: "ASC",
  },
  amount_desc: {
    column: "AMOUNT",
    type: "DESC",
  },
  amount_asc: {
    column: "AMOUNT",
    type: "ASC",
  },
  type_desc: {
    column: "TYPE",
    type: "DESC",
  },
  type_asc: {
    column: "TYPE",
    type: "ASC",
  },
};

export const statusFilterTransaction1 = [
  {
    label: "Waiting for Approval",
    value: 2,
  },
  {
    label: "Wait for Confirmation",
    value: 1,
  },
  {
    label: "Succeeded",
    value: 3,
  },
  {
    label: "Rejected",
    value: 4,
  },
  {
    label: "Expired",
    value: 5,
  },
  // {
  //   label: "Failed",
  //   value: 6,
  // },
  {
    label: "Cancelled",
    value: 7,
  },
];

export const statusFilterTransaction2 = [
  {
    label: "Waiting for Approval",
    value: 2,
  },
  {
    label: "Succeeded",
    value: 3,
  },
  {
    label: "Rejected",
    value: 4,
  },
  { label: "Approved", value: 8 },
  { label: "Process", value: 9 },
  // {
  //   label: "Expired",
  //   value: 5,
  // },
  // {
  //   label: "Failed",
  //   value: 6,
  // },
  // {
  //   label: "Cancelled",
  //   value: 7,
  // },
];

export const typeTransactionOptions = (type, country) => {
  let defaultVals = [
    {
      label: "All",
      value: null,
    },
    {
      label: "Deposit",
      value: 1,
    },
    {
      label: "Withdraw",
      value: 2,
    },
    {
      label: "Transfer",
      value: 3,
    },
    {
      label: "Checkout",
      value: 4,
    },
    {
      label: "Sell Item",
      value: 5,
    },
    {
      label: "Order Fee",
      value: 6,
    },
    {
      label: "Service Fee",
      value: 7,
    },
    {
      label: "Withdrawal Fee",
      value: 8,
    },
    {
      label: "Subscription Benefit",
      value: 11,
    },
  ];

  if (type === "crypto") {
    if (country === "JP") {
      defaultVals = defaultVals.filter(
        (item) => item.value !== 1 && item.value !== 4
      );
    }
    return defaultVals.filter((item) => item.value !== 3);
  }
  if (type === "option") {
    return defaultVals.filter(
      (item) =>
        item.value === 2 ||
        item.value === 8 ||
        item.value === 11 ||
        item.value === ""
    );
  }

  if (type === "gameCurrency" || type === "sztConversion") {
    return defaultVals.filter(
      (item) => item.value === 1 || item.value === 2 || item.value === ""
    );
  }

  return defaultVals;
};

export const typeBalanceOptions = (type, code, country) => {
  const defaultValsSZT = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Withdraw",
      value: 2,
    },
    {
      label: "Buy",
      value: 3,
    },
    {
      label: "Walking rewards",
      value: 4,
    },
    {
      label: "Sell",
      value: 5,
    },
    // {
    //   label: "Admin Deposit",
    //   value: 9,
    // },
    {
      label: "Deposit",
      value: 10,
    },
    // {
    //   label: "MLM Deposit",
    //   value: 11,
    // },
    // {
    //   label: "Scholar walking rewards",
    //   value: 12,
    // },
    // {
    //   label: "Contract fee",
    //   value: 13,
    // },
    // {
    //   label: "Participant reward",
    //   value: 14,
    // },
    // {
    //   label: "Leader board reward",
    //   value: 15,
    // },
    {
      label: "Bonus energy",
      value: 16,
    },
    {
      label: "Refund for customer",
      value: 17,
    },
    {
      label: "Bonus for staff",
      value: 18,
    },
    {
      label: "Adjust",
      value: 19,
    },
    {
      label: "Salary",
      value: 20,
    },
    {
      label: "Outsource Service",
      value: 21,
    },
    {
      label: "Event Reward",
      value: 22,
    },
    {
      label: "SZT bonus type",
      value: 23,
    },
    {
      label: "Top up e-Wallet",
      value: 24,
    },
    {
      label: "Top up e-Wallet fee",
      value: 25,
    },
    {
      label: "Reverse Top up e-Wallet",
      value: 26,
    },
    {
      label: "Affiliate commission",
      value: 42,
    },
  ];
  const defaultValsSGT = [
    {
      label: "All",
      value: "",
    },
    {
      label: "SGT Walking Reward",
      value: 30,
    },

    {
      label: "SGT Buy",
      value: 31,
    },

    {
      label: "SGT Sell",
      value: 32,
    },

    {
      label: "SGT Deposit",
      value: 33,
    },

    {
      label: "SGT Withdraw",
      value: 34,
    },
    {
      label: "SGT Adjustment",
      value: 35,
    },
    {
      label: "Withdraw SGT Fee",
      value: 37,
    },
    {
      label: "Reverse SGT Withdrawal",
      value: 36,
    },
  ];

  const defaultVals = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Deposit",
      value: 1,
    },
    {
      label: "Withdrawal",
      value: 2,
    },
    {
      label: "ETH deposit excess amount",
      value: 3,
    },
    {
      label: "Internal convert/transfer",
      value: 5,
    },
    {
      label: `{currency_code} distribution`,
      value: 10,
    },
    {
      label: `Adjust`,
      value: 11,
    },
    {
      label: `SOT for affiliate`,
      value: 12,
    },
    {
      label: `{currency_code} balance correction`,
      value: 18,
    },
    {
      label: "Distribution for Art Plus",
      value: 19,
    },
    {
      label: "Distribution for AI Subscription",
      value: 20,
    },
    {
      label: "Distribution for Subscription",
      value: 21,
    },
    {
      label: "Distribution for ART PRIME",
      value: 22,
    },
    {
      label: "Adjustment for send NFT Avatar",
      value: 23,
    },
    {
      label: "Adjustment for receive NFT Avatar",
      value: 24,
    },
    {
      label: "Adjustment for pending NFT Avatar",
      value: 25,
    },
    {
      label: `Transaction fee`,
      value: 36,
    },
    {
      label: `Buy item`,
      value: 37,
    },
    {
      label: `Sell item`,
      value: 38,
    },
    {
      label: `Refund`,
      value: 39,
    },
    {
      label: `Royalty`,
      value: 40,
    },
    {
      label: `Token revoke`,
      value: 41,
    },
    {
      label: `Distribute-staff`,
      value: 42,
    },
    {
      label: `Token revoke-staff`,
      value: 43,
    },
  ];

  if (type === "crypto") {
    return defaultVals.filter(
      (item) =>
        item.value === 1 ||
        item.value === 2 ||
        item.value === 5 ||
        // item.value === 11 ||
        item.value === 18 ||
        item.value === 36 ||
        item.value === 37 ||
        item.value === 38 ||
        item.value === 39 ||
        item.value === 40 ||
        item.value === ""
    );
  }
  if (type === "option") {
    return defaultVals.filter(
      (item) =>
        item.value === 1 ||
        item.value === 2 ||
        item.value === 5 ||
        item.value === 10 ||
        item.value === 18 ||
        item.value === 19 ||
        item.value === 20 ||
        item.value === 21 ||
        item.value === 22 ||
        item.value === 23 ||
        item.value === 24 ||
        item.value === 25 ||
        item.value === 12 ||
        item.value === 41 ||
        item.value === 42 ||
        item.value === 43 ||
        item.value === ""
    );
  }
  if (type === "gameCurrency" || code === "SZT") {
    return defaultValsSZT;
  }
  if (type === "gameCurrencySGT" || code === "SGT") {
    return defaultValsSGT;
  }
  return defaultVals.filter((item) => item.value === "");
};
export const tabTransactionOptions = [
  {
    label: "Crypto",
    value: "crypto",
  },
  {
    label: "Conversion",
    value: "sztConversion",
  },
  {
    label: "Option",
    value: "option",
  },
  {
    label: "Commission",
    value: "commission",
  },
];

export const StatusEnabled2FA = {
  ENABLE: 1,
  ENABLE2: 2,
  DISABLE: 0,
};

export const KEY_COOKIE = {
  LOCALE: "suzu_locale",
  AUTH_TOKEN_COOOKIE: process.env.REACT_APP_AUTH_COOKIE_KEY,
  STATUS_VERIFY_PHONE: "status-verify-phone",
};

export const DOMAIN_COOKIE =
  process.env.NODE_ENV === "production" ? ".aiavatar.fun" : "localhost";

export const regexPassword = /^(?=.*[a-zA-Z])[a-zA-Z0-9]{6}$/;

export const MAP_PRIVEW_TITLE = {
  "/": "Wallets",
  "/stake": "Stake",
  "/commission": "Commission",
};

export const USD = "$";
export const JPY = "￥";
export const BTC = "BTC";
export const ETH = "ETH";
export const THB = "฿";
export const IDR = "Rp";
export const PHP = "₱";
export const MYR = "RM";
export const VND = "đ";
export const BRL = 'R$';

export const MapCurrency = {
  USD: USD,
  JPY: JPY,
  BTC: BTC,
  ETH: ETH,
  VND: VND,
  MYR: MYR,
  PHP: PHP,
  THB: THB,
  IDR: IDR,
  BRL: BRL,
};

export const MIN_CONVERT_AMOUNT = 0.001;

export const CountryCode = {
  indo: "ID",
  vietnam: "VN",
};

export const FORMAT_BALANCE_BY_CURRENCY = {
  USD: 2,
  JPY: 0,
  KRW: 0,
  IDR: 0,
  PHP: 2,
  VND: 0,
  THB: 2,
  MYR: 2,
  BDT: 2,
  BRL: 2,
};
export const SALE_TYPE = {
  NONE: 0,
  AUCTION: 1,
  FIXED_PRICE: 2,
};
export const ITEM_STATUS = {
  Processing: 0,
  Confirmed: 1,
  Issues: 2,
  Paying: 3,
  Failed: 4,
  Deleted: 9,
};
export const APP_CONNECT_TYPE = {
  facebook: "facebook",
  apple: "appleid",
  instagram: "instagram",
  google: "google",
};

export const SSO_COOKIE_NAME = "auth-token-test";

export const SORT_TYPE = {
  CREATED_TIME: 1,
  LOWEST_PRICE: 2,
  HIGHTEST_PRICE: 3,
  MOST_LIKED: 4,
  LISTED_TIME: 5,
  EXPIRE_TIME: 6,
  CREATED_TIME_DESC: 5,
  CREATED_TIME_ASC: 4,
};

export const SORT_TYPE_OPTIONS = [
  { value: SORT_TYPE.HIGHTEST_PRICE, text: "Price high to low" },
  { value: SORT_TYPE.LOWEST_PRICE, text: "Price low to high" },
  { value: SORT_TYPE.CREATED_TIME_DESC, text: "Newest to Oldest" },
  { value: SORT_TYPE.CREATED_TIME_ASC, text: "Oldest to Newest" },
];
export const SORT_TYPE_PRIME_OPTIONS = [
  { value: SORT_TYPE.CREATED_TIME_DESC, text: "Lastest NFT" },
  { value: SORT_TYPE.CREATED_TIME_ASC, text: "Oldest NFT" },
];
export const SORT_SUB_OPTIONS = [
  { value: "priceDesc", text: "Highest charge" },
  { value: "priceAsc", text: "Lowest charge" },
  { value: "createTimeDesc", text: "Newest subscription" },
  { value: "createTimeAsc", text: "Oldest subscription" },
];

export const SORT_SUB_MAPPING_KEY = {
  priceDesc: {
    column: "price",
    direction: "desc",
  },
  priceAsc: {
    column: "price",
    direction: "asc",
  },
  createTimeDesc: {
    column: "createTime",
    direction: "desc",
  },
  createTimeAsc: {
    column: "createTime",
    direction: "asc",
  },
};

export const ITEM_TYPES = {
  ITEM_TYPE_PET_3D: 6,
  ITEM_TYPE_AVATAR_3D: 7,
  ITEM_TYPE_PHYSICAL: 8,
  ITEM_TYPE_DOG: 9,
  ITEM_TYPE_PROP: 10,
  ITEM_TYPE_SUBSCRIPTION: 11,
  ITEM_TYPE_PRIME: 14,
};

export const ITEM_POSITION_ENUMS = {
  ITEM_POSITION_MY_PAGE: "mypage",
  ITEM_POSITION_MARKETPLACE: "market",
  ITEM_POSITION_APP: "app",
};

export const EARNER_DEFAULT_PARAMS = {
  name: null,
  breeds: [],
  priceFrom: null,
  priceTo: null,
  rankCode: [],
  genders: [],
  tagNFT: [],
  isMintNft: [],
  sort: SORT_TYPE.CREATED_TIME_DESC,
};

export const CHARACTER_DEFAULT_PARAMS = {
  name: null,
  priceFrom: null,
  priceTo: null,
  animationIds: [],
  giftTypes: [],
  sort: SORT_TYPE.CREATED_TIME_DESC,
};
export const PRIME_DEFAULT_PARAMS = {
  name: null,
  isMintNft: [],
  skus: [],
  sort: SORT_TYPE.CREATED_TIME_DESC,
};
export const ADDRESS_BOOK_DEFAULT_PARAMS = {
  name: null,
  network: null,
};

export const ITEM_LIMIT = 12;
export const ADDRESS_BOOK_LIMIT = 10;

export const SUBSCRIPTION = {
  PREMIUM: 1,
  UNLIMITED: 2,
  ESSENTIAL: 3,
};
export const SUBSCRIPTION_V2 = {
  PREMIUM: "SUB_PRE",
  UNLIMITED: "SUB_UN",
  ESSENTIAL: "SUB_PRE_SOT",
};

export const CLAIM_DATA_KEY = "claim_data_params";
export const HEIGHT_FULL_CHART_AFFILIATE = 185;
export const IPFS_HOST = "infura-ipfs.io";
export const IPFS_URL = "https://btrans.infura-ipfs.io/ipfs";

export const MAPPING_LOCALES = {
  en: "en",
  ja: "jp",
  ko: "ko",
  cn: "cn",
  tc: "tc",
  vi: "vi",
  id: "id",
  pt: "pt",
  es: "es",
};

export const COUNTRY_CODES = {
  AFGHANISTAN: "AF",
  ALBANIA: "AL",
  ALGERIA: "DZ",
  AMERICAN_SAMOA: "AS",
  ANDORRA: "AD",
  ANGOLA: "AO",
  ANGUILLA: "AI",
  ANTARCTICA: "AQ",
  ANTIGUA_AND_BARBUDA: "AG",
  ARGENTINA: "AR",
  ARMENIA: "AM",
  ARUBA: "AW",
  AUSTRALIA: "AU",
  AUSTRIA: "AT",
  AZERBAIJAN: "AZ",
  BAHAMAS: "BS",
  BAHRAIN: "BH",
  BANGLADESH: "BD",
  BARBADOS: "BB",
  BELARUS: "BY",
  BELGIUM: "BE",
  BELIZE: "BZ",
  BENIN: "BJ",
  BERMUDA: "BM",
  BHUTAN: "BT",
  BOLIVIA: "BO",
  BOSNIA_AND_HERZEGOVINA: "BA",
  BOTSWANA: "BW",
  BRAZIL: "BR",
  BRITISH_INDIAN_OCEAN_TERRITORY: "IO",
  BRITISH_VIRGIN_ISLANDS: "VG",
  BRUNEI: "BN",
  BULGARIA: "BG",
  BURKINA_FASO: "BF",
  BURUNDI: "BI",
  CAMBODIA: "KH",
  CAMEROON: "CM",
  CANADA: "CA",
  CAPE_VERDE: "CV",
  CAYMAN_ISLANDS: "KY",
  CENTRAL_AFRICAN_REPUBLIC: "CF",
  CHAD: "TD",
  CHILE: "CL",
  CHINA: "CN",
  CHRISTMAS_ISLAND: "CX",
  COCOS_ISLANDS: "CC",
  COLOMBIA: "CO",
  COMOROS: "KM",
  COOK_ISLANDS: "CK",
  COSTA_RICA: "CR",
  CROATIA: "HR",
  CUBA: "CU",
  CURACAO: "CW",
  CYPRUS: "CY",
  CZECH_REPUBLIC: "CZ",
  DEMOCRATIC_REPUBLIC_OF_THE_CONGO: "CD",
  DENMARK: "DK",
  DJIBOUTI: "DJ",
  DOMINICA: "DM",
  DOMINICAN_REPUBLIC: "DO",
  EAST_TIMOR: "TL",
  ECUADOR: "EC",
  EGYPT: "EG",
  EL_SALVADOR: "SV",
  EQUATORIAL_GUINEA: "GQ",
  ERITREA: "ER",
  ESTONIA: "EE",
  ETHIOPIA: "ET",
  FALKLAND_ISLANDS: "FK",
  FAROE_ISLANDS: "FO",
  FIJI: "FJ",
  FINLAND: "FI",
  FRANCE: "FR",
  FRENCH_POLYNESIA: "PF",
  GABON: "GA",
  GAMBIA: "GM",
  GEORGIA: "GE",
  GERMANY: "DE",
  GHANA: "GH",
  GIBRALTAR: "GI",
  GREECE: "GR",
  GREENLAND: "GL",
  GRENADA: "GD",
  GUAM: "GU",
  GUATEMALA: "GT",
  GUERNSEY: "GG",
  GUINEA: "GN",
  GUINEA_BISSAU: "GW",
  GUYANA: "GY",
  HAITI: "HT",
  HONDURAS: "HN",
  HONG_KONG: "HK",
  HUNGARY: "HU",
  ICELAND: "IS",
  INDIA: "IN",
  INDONESIA: "ID",
  IRAN: "IR",
  IRAQ: "IQ",
  IRELAND: "IE",
  ISLE_OF_MAN: "IM",
  ISRAEL: "IL",
  ITALY: "IT",
  IVORY_COAST: "CI",
  JAMAICA: "JM",
  JAPAN: "JP",
  JERSEY: "JE",
  JORDAN: "JO",
  KAZAKHSTAN: "KZ",
  KENYA: "KE",
  KIRIBATI: "KI",
  KOSOVO: "XK",
  KUWAIT: "KW",
  KYRGYZSTAN: "KG",
  LAOS: "LA",
  LATVIA: "LV",
  LEBANON: "LB",
  LESOTHO: "LS",
  LIBERIA: "LR",
  LIBYA: "LY",
  LIECHTENSTEIN: "LI",
  LITHUANIA: "LT",
  LUXEMBOURG: "LU",
  MACAU: "MO",
  NORTH_MACEDONIA: "MK",
  MADAGASCAR: "MG",
  MALAWI: "MW",
  MALAYSIA: "MY",
  MALDIVES: "MV",
  MALI: "ML",
  MALTA: "MT",
  MARSHALL_ISLANDS: "MH",
  MAURITANIA: "MR",
  MAURITIUS: "MU",
  MAYOTTE: "YT",
  MEXICO: "MX",
  MICRONESIA: "FM",
  MOLDOVA: "MD",
  MONACO: "MC",
  MONGOLIA: "MN",
  MONTENEGRO: "ME",
  MONTSERRAT: "MS",
  MOROCCO: "MA",
  MOZAMBIQUE: "MZ",
  MYANMAR: "MM",
  NAMIBIA: "NA",
  NAURU: "NR",
  NEPAL: "NP",
  NETHERLANDS: "NL",
  NETHERLANDS_ANTILLES: "AN",
  NEW_CALEDONIA: "NC",
  NEW_ZEALAND: "NZ",
  NICARAGUA: "NI",
  NIGER: "NE",
  NIGERIA: "NG",
  NIUE: "NU",
  NORTH_KOREA: "KP",
  NORTHERN_MARIANA_ISLANDS: "MP",
  NORWAY: "NO",
  OMAN: "OM",
  PAKISTAN: "PK",
  PALAU: "PW",
  PALESTINE: "PS",
  PANAMA: "PA",
  PAPUA_NEW_GUINEA: "PG",
  PARAGUAY: "PY",
  PERU: "PE",
  PHILIPPINES: "PH",
  PITCAIRN: "PN",
  POLAND: "PL",
  PORTUGAL: "PT",
  PUERTO_RICO: "PR",
  QATAR: "QA",
  REPUBLIC_OF_THE_CONGO: "CG",
  REUNION: "RE",
  ROMANIA: "RO",
  RUSSIA: "RU",
  RWANDA: "RW",
  SAINT_BARTHELEMY: "BL",
  SAINT_HELENA: "SH",
  SAINT_KITTS_AND_NEVIS: "KN",
  SAINT_LUCIA: "LC",
  SAINT_MARTIN: "MF",
  SAINT_PIERRE_AND_MIQUELON: "PM",
  SAINT_VINCENT_AND_THE_GRENADINES: "VC",
  SAMOA: "WS",
  SAN_MARINO: "SM",
  SAO_TOME_AND_PRINCIPE: "ST",
  SAUDI_ARABIA: "SA",
  SENEGAL: "SN",
  SERBIA: "RS",
  SEYCHELLES: "SC",
  SIERRA_LEONE: "SL",
  SINGAPORE: "SG",
  SINT_MAARTEN: "SX",
  SLOVAKIA: "SK",
  SLOVENIA: "SI",
  SOLOMON_ISLANDS: "SB",
  SOMALIA: "SO",
  SOUTH_AFRICA: "ZA",
  SOUTH_KOREA: "KR",
  SOUTH_SUDAN: "SS",
  SPAIN: "ES",
  SRI_LANKA: "LK",
  SUDAN: "SD",
  SURINAME: "SR",
  SVALBARD: "SJ",
  SWAZILAND: "SZ",
  SWEDEN: "SE",
  SWITZERLAND: "CH",
  SYRIA: "SY",
  TAIWAN: "TW",
  TAJIKISTAN: "TJ",
  TANZANIA: "TZ",
  THAILAND: "TH",
  TOGO: "TG",
  TOKELAU: "TK",
  TONGA: "TO",
  TRINIDAD_AND_TOBAGO: "TT",
  TUNISIA: "TN",
  TURKEY: "TR",
  TURKMENISTAN: "TM",
  TURKS_AND_CAICOS_ISLANDS: "TC",
  TUVALU: "TV",
  US_VIRGIN_ISLANDS: "VI",
  UGANDA: "UG",
  UKRAINE: "UA",
  UNITED_ARAB_EMIRATES: "AE",
  UNITED_KINGDOM: "GB",
  UNITED_STATES: "US",
  URUGUAY: "UY",
  UZBEKISTAN: "UZ",
  VANUATU: "VU",
  VATICAN: "VA",
  VENEZUELA: "VE",
  VIETNAM: "VN",
  WALLIS_AND_FUTUNA: "WF",
  WESTERN_SAHARA: "EH",
  YEMEN: "YE",
  ZAMBIA: "ZM",
  ZIMBABWE: "ZW",
};

export const PHONE_CODES = {
  AF: "+93",
  AL: "+355",
  DZ: "+213",
  AS: "+1-684",
  AD: "+376",
  AO: "+244",
  AI: "+1-264",
  AQ: "+672",
  AG: "+1-268",
  AR: "+54",
  AM: "+374",
  AW: "+297",
  AU: "+61",
  AT: "+43",
  AZ: "+994",
  BS: "+1-242",
  BH: "+973",
  BD: "+880",
  BB: "+1-246",
  BY: "+375",
  BE: "+32",
  BZ: "+501",
  BJ: "+229",
  BM: "+1-441",
  BT: "+975",
  BO: "+591",
  BA: "+387",
  BW: "+267",
  BR: "+55",
  IO: "+246",
  VG: "+1-284",
  BN: "+673",
  BG: "+359",
  BF: "+226",
  BI: "+257",
  KH: "+855",
  CM: "+237",
  CA: "+1",
  CV: "+238",
  KY: "+1-345",
  CF: "+236",
  TD: "+235",
  CL: "+56",
  CN: "+86",
  CX: "+61",
  CC: "+61",
  CO: "+57",
  KM: "+269",
  CK: "+682",
  CR: "+506",
  HR: "+385",
  CU: "+53",
  CW: "+599",
  CY: "+357",
  CZ: "+420",
  CD: "+243",
  DK: "+45",
  DJ: "+253",
  DM: "+1-767",
  DO: "+1-809",
  TL: "+670",
  EC: "+593",
  EG: "+20",
  SV: "+503",
  GQ: "+240",
  ER: "+291",
  EE: "+372",
  ET: "+251",
  FK: "+500",
  FO: "+298",
  FJ: "+679",
  FI: "+358",
  FR: "+33",
  PF: "+689",
  GA: "+241",
  GM: "+220",
  GE: "+995",
  DE: "+49",
  GH: "+233",
  GI: "+350",
  GR: "+30",
  GL: "+299",
  GD: "+1-473",
  GU: "+1-671",
  GT: "+502",
  GG: "+44-1481",
  GN: "+224",
  GW: "+245",
  GY: "+592",
  HT: "+509",
  HN: "+504",
  HK: "+852",
  HU: "+36",
  IS: "+354",
  IN: "+91",
  ID: "+62",
  IR: "+98",
  IQ: "+964",
  IE: "+353",
  IM: "+44-1624",
  IL: "+972",
  IT: "+39",
  CI: "+225",
  JM: "+1-876",
  JP: "+81",
  JE: "+44-1534",
  JO: "+962",
  KZ: "+7",
  KE: "+254",
  KI: "+686",
  XK: "+383",
  KW: "+965",
  KG: "+996",
  LA: "+856",
  LV: "+371",
  LB: "+961",
  LS: "+266",
  LR: "+231",
  LY: "+218",
  LI: "+423",
  LT: "+370",
  LU: "+352",
  MO: "+853",
  MK: "+389",
  MG: "+261",
  MW: "+265",
  MY: "+60",
  MV: "+960",
  ML: "+223",
  MT: "+356",
  MH: "+692",
  MR: "+222",
  MU: "+230",
  YT: "+262",
  MX: "+52",
  FM: "+691",
  MD: "+373",
  MC: "+377",
  MN: "+976",
  ME: "+382",
  MS: "+1-664",
  MA: "+212",
  MZ: "+258",
  MM: "+95",
  NA: "+264",
  NR: "+674",
  NP: "+977",
  NL: "+31",
  AN: "+599",
  NC: "+687",
  NZ: "+64",
  NI: "+505",
  NE: "+227",
  NG: "+234",
  NU: "+683",
  KP: "+850",
  MP: "+1-670",
  NO: "+47",
  OM: "+968",
  PK: "+92",
  PW: "+680",
  PS: "+970",
  PA: "+507",
  PG: "+675",
  PY: "+595",
  PE: "+51",
  PH: "+63",
  PN: "+64",
  PL: "+48",
  PT: "+351",
  PR: "+1-787",
  QA: "+974",
  CG: "+242",
  RE: "+262",
  RO: "+40",
  RU: "+7",
  RW: "+250",
  BL: "+590",
  SH: "+290",
  KN: "+1-869",
  LC: "+1-758",
  MF: "+590",
  PM: "+508",
  VC: "+1-784",
  WS: "+685",
  SM: "+378",
  ST: "+239",
  SA: "+966",
  SN: "+221",
  RS: "+381",
  SC: "+248",
  SL: "+232",
  SG: "+65",
  SX: "+1-721",
  SK: "+421",
  SI: "+386",
  SB: "+677",
  SO: "+252",
  ZA: "+27",
  KR: "+82",
  SS: "+211",
  ES: "+34",
  LK: "+94",
  SD: "+249",
  SR: "+597",
  SJ: "+47",
  SZ: "+268",
  SE: "+46",
  CH: "+41",
  SY: "+963",
  TW: "+886",
  TJ: "+992",
  TZ: "+255",
  TH: "+66",
  TG: "+228",
  TK: "+690",
  TO: "+676",
  TT: "+1-868",
  TN: "+216",
  TR: "+90",
  TM: "+993",
  TC: "+1-649",
  TV: "+688",
  VI: "+1-340",
  UG: "+256",
  UA: "+380",
  AE: "+971",
  GB: "+44",
  US: "+1",
  UY: "+598",
  UZ: "+998",
  VU: "+678",
  VA: "+379",
  VE: "+58",
  VN: "+84",
  WF: "+681",
  EH: "+212",
  YE: "+967",
  ZM: "+260",
  ZW: "+263",
};
export const bannerIcon = {
  asset: (
    <svg
      width="35"
      height="39"
      viewBox="0 0 35 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_21838_35957"
        maskUnits="userSpaceOnUse"
        x="5"
        y="6"
        width="25"
        height="28"
      >
        <path
          d="M29.2278 6.39258H5.64062V33.1178H29.2278V6.39258Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_21838_35957)">
        <path
          d="M21.3478 13.2169C21.3954 11.0366 21.9333 9.31544 22.8269 7.52846C23.1617 6.85897 22.4481 6.1421 21.7766 6.47818L19.1497 7.79158L17.9828 6.62483C17.6772 6.31903 17.1815 6.31903 16.8757 6.62483L15.709 7.79158L13.0822 6.47797C12.4125 6.1433 11.696 6.85672 12.0319 7.52846C12.9199 9.3042 13.4632 11.0264 13.511 13.2169L9.5795 17.9758C8.07855 19.7928 7.25195 22.0933 7.25195 24.4538C7.25195 30.0415 11.7434 33.1178 17.4296 33.1178C23.116 33.1178 27.6068 30.0407 27.6068 24.4538C27.6068 22.0933 26.7802 19.7928 25.2792 17.9758L21.3478 13.2169ZM15.5135 9.44436C15.815 9.59488 16.1789 9.53604 16.4171 9.29766L17.4296 8.28556L18.4417 9.29766C18.6799 9.53604 19.0439 9.59488 19.3452 9.44436L20.5563 8.83899C20.1285 10.0801 19.8722 11.3878 19.7996 12.7109H15.0591C14.9866 11.3878 14.7302 10.0801 14.3027 8.83899L15.5135 9.44436ZM17.4296 31.552C13.4569 31.552 8.81765 29.6932 8.81765 24.454C8.81765 22.4566 9.5168 20.5101 10.7867 18.9731L14.6667 14.2766H20.1921L24.0721 18.9731C25.3418 20.5101 26.0411 22.4564 26.0411 24.454C26.0411 29.6932 21.4021 31.552 17.4296 31.552Z"
          fill="black"
        />
      </g>
      <path
        d="M8.42643 14.3824C8.05196 14.1662 7.57331 14.2943 7.35695 14.6688C7.14079 15.0431 7.26908 15.5222 7.64355 15.7383C8.01807 15.9544 8.49672 15.8261 8.71308 15.4517C8.92924 15.0772 8.80089 14.5985 8.42643 14.3824Z"
        fill="black"
      />
      <path
        d="M17.423 20.7699C17.8545 20.7699 18.2057 21.1213 18.2057 21.5529C18.2057 21.9852 18.5562 22.3356 18.9888 22.3356C19.4209 22.3356 19.7714 21.9852 19.7714 21.5529C19.7714 20.5355 19.1209 19.6673 18.214 19.3416V18.1921C18.214 17.7595 17.8635 17.4092 17.4314 17.4092C16.9989 17.4092 16.6483 17.7595 16.6483 18.1921V19.3361C15.7329 19.6569 15.0742 20.5292 15.0742 21.5529C15.0742 22.8479 16.1278 23.9015 17.423 23.9015C17.8545 23.9015 18.2057 24.2527 18.2057 24.6844C18.2057 25.116 17.8545 25.4674 17.423 25.4674C16.9912 25.4674 16.64 25.116 16.64 24.6844C16.64 24.2521 16.2894 23.9015 15.8571 23.9015C15.4248 23.9015 15.0742 24.2521 15.0742 24.6844C15.0742 25.7081 15.7329 26.5804 16.6483 26.9012V27.5866C16.6483 28.0189 16.9989 28.3695 17.4314 28.3695C17.8635 28.3695 18.214 28.0189 18.214 27.5866V26.8955C19.1209 26.57 19.7714 25.7018 19.7714 24.6844C19.7714 23.3891 18.7178 22.3356 17.423 22.3356C16.9912 22.3356 16.64 21.9846 16.64 21.5527C16.64 21.1211 16.9912 20.7699 17.423 20.7699Z"
        fill="black"
      />
      <path
        d="M28.3931 12.7113H27.61V11.9282C27.61 11.4959 27.2594 11.1455 26.8271 11.1455C26.3948 11.1455 26.0443 11.4959 26.0443 11.9282V12.7113H25.2614C24.8291 12.7113 24.4785 13.0616 24.4785 13.4939C24.4785 13.9264 24.8291 14.277 25.2614 14.277H26.0443V15.0598C26.0443 15.4921 26.3948 15.8427 26.8271 15.8427C27.2594 15.8427 27.61 15.4921 27.61 15.0598V14.277H28.3931C28.8254 14.277 29.1757 13.9264 29.1757 13.4939C29.1757 13.0616 28.8254 12.7113 28.3931 12.7113Z"
        fill="black"
      />
      <path
        d="M7.2532 10.31C7.2532 10.7423 7.60377 11.0929 8.03608 11.0929C8.46833 11.0929 8.8189 10.7423 8.8189 10.31V9.52717H9.60178C10.0341 9.52717 10.3847 9.17639 10.3847 8.74429C10.3847 8.31198 10.0341 7.96121 9.60178 7.96121H8.8189V7.17833C8.8189 6.74607 8.46833 6.39551 8.03608 6.39551C7.60377 6.39551 7.2532 6.74607 7.2532 7.17833V7.96121H6.47011C6.03807 7.96121 5.6875 8.31198 5.6875 8.74429C5.6875 9.17639 6.03807 9.52717 6.47011 9.52717H7.2532V10.31Z"
        fill="black"
      />
    </svg>
  ),
  wallet: (
    <svg
      width="64"
      height="70"
      viewBox="0 0 64 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.983 24.0122L41.9828 24.0119C41.8372 23.7594 41.6019 23.5789 41.3202 23.5035C41.0388 23.4283 40.745 23.4671 40.4928 23.6127L37.7351 25.2055C37.4828 25.3507 37.3022 25.5855 37.2267 25.8669C37.1511 26.1485 37.1897 26.4427 37.3352 26.6944C37.5288 27.0311 37.8909 27.2402 38.2803 27.2402C38.4715 27.2402 38.6599 27.1897 38.825 27.0942L41.5838 25.5016C42.1038 25.2011 42.2828 24.5329 41.983 24.0122Z"
        fill="black"
      />
      <path
        d="M26.7932 31.8918C26.5116 31.8166 26.2177 31.8554 25.9658 32.001L22.8303 33.8121C22.5778 33.9575 22.3971 34.1926 22.3216 34.4743C22.2463 34.7554 22.2848 35.0492 22.43 35.3014L22.4303 35.3018C22.6245 35.638 22.9864 35.8469 23.3749 35.8469C23.5658 35.8469 23.7543 35.7964 23.9201 35.7006L27.056 33.89C27.5765 33.5898 27.7559 32.9216 27.4557 32.4003C27.3102 32.1478 27.0747 31.9673 26.7932 31.8918Z"
        fill="black"
      />
      <path
        d="M58.3161 29.8908L55.2411 28.1249L58.3184 26.3483C58.6555 26.1538 58.8645 25.7913 58.8637 25.4021C58.8627 25.0135 58.653 24.6518 58.316 24.4578C52.112 20.8967 45.9085 17.3335 39.705 13.7695C39.3692 13.5765 38.9521 13.5768 38.6164 13.7705L5.6826 32.7854C5.34507 32.9792 5.13591 33.3418 5.1367 33.732C5.13767 34.1207 5.34745 34.4823 5.68392 34.6756C6.31405 35.0379 6.94462 35.4 7.5751 35.762C7.96972 35.9887 8.36444 36.2152 8.75906 36.4419L5.68198 38.2184C5.34437 38.4123 5.1352 38.7748 5.13617 39.1642C5.13697 39.5537 5.34692 39.9156 5.68357 40.1085L8.75871 41.8749L5.68146 43.651C5.34428 43.8456 5.13529 44.208 5.13626 44.597C5.13705 44.9856 5.34674 45.3475 5.68375 45.5415L24.2947 56.2297C24.4599 56.3248 24.648 56.375 24.8383 56.375C25.0294 56.375 25.218 56.3244 25.3835 56.2288L58.3182 37.2137C58.6555 37.0194 58.8646 36.6569 58.8638 36.2675C58.8628 35.8792 58.6531 35.5176 58.3162 35.3238L55.2412 33.5579L58.3185 31.7813C58.6556 31.5868 58.8646 31.2243 58.8638 30.8352V30.8352C58.8627 30.4464 58.653 30.0847 58.3161 29.8908ZM36.9172 21.4871C38.1307 21.8768 39.4583 21.9273 40.6109 21.6275L47.1263 25.3718C47.1098 25.6571 47.135 25.944 47.2022 26.2294L40.446 30.1278C37.6847 28.5422 33.9585 26.3978 31.1821 24.7995L36.9172 21.4871ZM49.118 27.6419C49.3749 27.4929 49.5622 27.2427 49.6312 26.9572C49.7023 26.6693 49.6512 26.3606 49.4911 26.1107C49.3796 25.936 49.2143 25.593 49.3605 25.2582C49.582 24.7484 49.3855 24.1549 48.9034 23.8776L41.2839 19.4985C41.0013 19.337 40.665 19.3093 40.3599 19.4227C39.4662 19.7568 38.239 19.7012 37.2327 19.281C36.9202 19.1511 36.5593 19.1747 36.2679 19.3435L28.9973 23.5415L27.5231 22.693L39.1632 15.9737C44.6375 19.1191 50.112 22.2629 55.5873 25.4062L43.9404 32.1289C43.6384 31.9574 43.2014 31.7077 42.6346 31.383L49.118 27.6419ZM42.8786 43.6095L39.7681 45.4055L39.7465 36.4346C39.7457 36.0461 39.5358 35.6846 39.1989 35.4912C39.1989 35.4912 26.7696 28.3569 22.2287 25.7488L25.3402 23.9531C27.1959 25.0214 40.791 32.8469 42.8596 34.0072L42.8786 43.6095ZM10.9458 43.131L24.2959 50.7981C24.6279 50.9872 25.0525 50.9866 25.3833 50.7961L37.5829 43.7525L37.59 46.6632L24.8365 54.0263L8.41245 44.5933L10.9458 43.131ZM27.8276 37.2325L27.0954 37.6557C26.4055 37.4342 25.6784 37.3226 24.9674 37.3226C24.4287 37.3226 23.8991 37.3868 23.4019 37.5159L16.8885 33.7777C16.9051 33.4925 16.8797 33.2059 16.8127 32.9209L23.5554 29.0252C26.5225 30.7297 29.4898 32.4334 32.4574 34.1368L32.825 34.3478C31.1586 35.3089 29.4932 36.2705 27.8276 37.2325ZM14.8972 31.5084C14.6407 31.6561 14.4533 31.9061 14.3828 32.1943C14.3127 32.482 14.3638 32.7902 14.5231 33.0394C14.6346 33.2143 14.7999 33.5577 14.6544 33.8923C14.4332 34.402 14.6297 34.9951 15.1115 35.2722L22.7282 39.6445C23.0115 39.8069 23.3486 39.8343 23.6525 39.7201C24.5464 39.3865 25.7741 39.4418 26.7781 39.8601C27.0844 39.9898 27.456 39.9667 27.7449 39.7988L28.9188 39.1212C30.9495 37.948 32.9804 36.775 35.0123 35.6032L36.4708 36.4407L24.8359 43.1599C19.3606 40.0172 13.8857 36.8733 8.41157 33.7276L20.0449 27.0096L20.6707 27.3689C20.9035 27.5025 21.1362 27.6361 21.3689 27.7697L14.8972 31.5084ZM24.2948 45.3641C24.6257 45.5541 25.0513 45.5542 25.3834 45.3631L37.5694 38.3244L37.5766 41.2376L24.8364 48.5932L8.41237 39.1603L10.9458 37.6976C15.3954 40.254 19.8446 42.8097 24.2948 45.3641ZM55.5874 30.8389L45.0464 36.9248L45.0407 34.0122L53.0565 29.3852L55.5874 30.8389ZM55.5874 36.2719L45.0574 42.3517L45.0515 39.4408L53.0571 34.8187L55.5874 36.2719Z"
        fill="black"
      />
    </svg>
  ),
  affilate: (
    <svg
      width="35"
      height="39"
      viewBox="0 0 35 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8291 20.9631C17.7673 20.9522 17.705 20.95 17.6435 20.9565C17.1762 20.8912 16.826 20.4912 16.8252 20.0175C16.8252 19.636 16.5148 19.3256 16.1333 19.3256C15.7518 19.3256 15.4414 19.636 15.4414 20.0178C15.4429 21.0158 16.0845 21.9029 17.0189 22.2239V22.5851C17.0189 22.9666 17.3293 23.277 17.7108 23.277C18.0923 23.277 18.4028 22.9666 18.4028 22.5851V22.2634C19.4919 21.9598 20.211 20.9181 20.0931 19.7776C19.9695 18.5851 18.9724 17.6857 17.7736 17.6854C17.2506 17.6854 16.8252 17.26 16.8252 16.7371C16.8252 16.2141 17.2506 15.7886 17.7736 15.7886C18.2966 15.7886 18.722 16.2141 18.722 16.7371C18.722 17.1186 19.0324 17.429 19.4139 17.429C19.7954 17.429 20.1059 17.1186 20.1059 16.7368C20.1043 15.6925 19.3969 14.7721 18.4028 14.4915V14.1841C18.4028 13.8026 18.0923 13.4922 17.7108 13.4922C17.3293 13.4922 17.0189 13.8026 17.0189 14.1841V14.5307C15.9769 14.8871 15.3139 15.9431 15.4622 17.0471C15.6166 18.1999 16.61 19.0691 17.7731 19.0691C17.7732 19.0691 17.7735 19.0691 17.7736 19.0691C18.2869 19.0691 18.712 19.4865 18.7213 19.9997C18.7307 20.5059 18.3324 20.9337 17.8291 20.9631Z"
        fill="black"
      />
      <path
        d="M17.77 25.879C21.8854 25.879 25.2335 22.5309 25.2335 18.4156C25.2335 14.3002 21.8854 10.9521 17.7698 10.9521C15.7773 10.9543 13.904 11.7315 12.4951 13.1405C11.0862 14.5494 10.309 16.4227 10.3066 18.4153V18.4156C10.3066 22.5309 13.6547 25.879 17.77 25.879ZM17.7702 12.336C21.1224 12.336 23.8496 15.0633 23.8496 18.4156C23.8496 21.7678 21.1224 24.495 17.77 24.495C14.4178 24.495 11.6905 21.7678 11.6905 18.4157C11.6943 15.0672 14.4216 12.3399 17.7702 12.336Z"
        fill="black"
      />
      <path
        d="M31.0294 27.8509C30.3143 26.582 28.7355 26.1006 27.4343 26.7538L23.6665 28.5342C23.0723 27.5586 22.0152 26.9401 20.8658 26.9076L17.239 26.8078C16.6964 26.7923 16.1547 26.6524 15.6727 26.4036L15.304 26.2125C13.455 25.2487 11.266 25.2037 9.3854 26.0772L9.39955 25.5568C9.40465 25.372 9.33754 25.1964 9.21057 25.0621C9.08356 24.9278 8.91178 24.851 8.72697 24.846L4.74969 24.7366C4.36749 24.7257 4.04958 25.0279 4.03919 25.4092L3.79909 34.1369C3.78862 34.5184 4.09036 34.8372 4.47167 34.8477L8.44886 34.9573L8.46785 34.9574C8.84561 34.9574 9.14951 34.6618 9.15967 34.2845L9.16818 33.9772L10.1044 33.4759C10.4683 33.2802 10.8876 33.2343 11.2855 33.3468L17.4542 35.0784C17.4688 35.0826 17.4832 35.0859 17.5004 35.0897C17.9572 35.1852 18.4255 35.2336 18.8921 35.2336C18.8943 35.2336 18.8965 35.2336 18.8986 35.2336C19.8832 35.2336 20.8762 35.0167 21.7697 34.6066C21.7997 34.5929 21.8292 34.5767 21.8566 34.5588L30.8026 28.7723C31.1095 28.5737 31.2091 28.1689 31.0294 27.8509ZM17.5265 29.5143C17.1467 29.505 16.8264 29.8055 16.8157 30.1871C16.8055 30.5684 17.1074 30.8872 17.4886 30.8977L23.4509 31.0618L23.4703 31.0619C23.8477 31.0615 24.1513 30.7659 24.1615 30.3888C24.1664 30.2061 24.1568 30.0236 24.1326 29.8443L28.0306 28.0024C28.0376 27.9992 28.0448 27.9957 28.05 27.993C28.472 27.7794 28.9744 27.8082 29.3672 28.0526L21.148 33.3696C20.0942 33.8421 18.9391 33.9703 17.8064 33.7403L11.66 32.0149C10.9161 31.8047 10.1314 31.8905 9.45076 32.2565L9.21219 32.3843L9.3417 27.6757C10.9447 26.6515 12.976 26.5595 14.6674 27.441L15.0368 27.6324C15.7025 27.9762 16.4508 28.1694 17.2009 28.1912L20.8278 28.291C21.6803 28.3156 22.4085 28.8652 22.674 29.6563L17.5265 29.5143ZM7.99741 26.2102L7.79514 33.5551L5.20141 33.4834L5.40341 26.1389L7.99741 26.2102Z"
        fill="black"
      />
      <path
        d="M17.772 10.4239C18.1535 10.4239 18.464 10.1135 18.464 9.732V4.96731C18.464 4.58578 18.1536 4.27539 17.772 4.27539C17.3905 4.27539 17.0801 4.58578 17.0801 4.96731V9.73205C17.0801 10.1135 17.3905 10.4239 17.772 10.4239Z"
        fill="black"
      />
      <path
        d="M21.5337 10.424C21.9152 10.424 22.2257 10.1136 22.2257 9.73204V7.47521C22.2257 7.09364 21.9152 6.7832 21.5337 6.7832C21.1522 6.7832 20.8418 7.09364 20.8418 7.47521V9.73209C20.8418 10.1136 21.1521 10.424 21.5337 10.424Z"
        fill="black"
      />
      <path
        d="M14.01 10.424C14.3916 10.424 14.702 10.1136 14.702 9.73204V7.47521C14.702 7.09364 14.3916 6.7832 14.01 6.7832C13.6286 6.7832 13.3184 7.09364 13.3184 7.47521V9.73209C13.3184 10.1136 13.6286 10.424 14.01 10.424Z"
        fill="black"
      />
    </svg>
  ),
  earn: (
    <svg
      width="64"
      height="70"
      viewBox="0 0 64 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.6499 37.1888C32.5377 37.1692 32.4249 37.1651 32.3134 37.177C31.4665 37.0585 30.8317 36.3336 30.8303 35.4751C30.8303 34.7836 30.2677 34.221 29.5762 34.221C28.8848 34.221 28.3223 34.7836 28.3223 35.4756C28.3249 37.2844 29.4879 38.8922 31.1814 39.474V40.1287C31.1814 40.8201 31.744 41.3827 32.4354 41.3827C33.1269 41.3827 33.6895 40.8201 33.6895 40.1287V39.5456C35.6635 38.9953 36.9667 37.1073 36.753 35.0403C36.5292 32.879 34.722 31.2489 32.5492 31.2484C31.6014 31.2484 30.8303 30.4773 30.8303 29.5296C30.8303 28.5818 31.6014 27.8106 32.5492 27.8106C33.4971 27.8106 34.2681 28.5817 34.2681 29.5296C34.2681 30.221 34.8307 30.7836 35.5221 30.7836C36.2136 30.7836 36.7762 30.2211 36.7762 29.5291C36.7735 27.6364 35.4913 25.9681 33.6895 25.4596V24.9025C33.6895 24.2111 33.1269 23.6484 32.4354 23.6484C31.744 23.6484 31.1814 24.211 31.1814 24.9025V25.5306C29.2927 26.1766 28.0913 28.0905 28.36 30.0915C28.6398 32.1809 30.4403 33.7562 32.5482 33.7561C32.5484 33.7561 32.5489 33.7561 32.5492 33.7561C33.4795 33.7561 34.2499 34.5127 34.2668 35.4428C34.2839 36.3602 33.5619 37.1355 32.6499 37.1888Z"
        fill="black"
      />
      <path
        d="M32.5444 46.1006C40.0032 46.1006 46.0713 40.0325 46.0713 32.5737C46.0713 25.115 40.0032 19.0469 32.544 19.0469C28.9327 19.0509 25.5375 20.4594 22.9839 23.0131C20.4304 25.5667 19.0219 28.9619 19.0176 32.5733V32.5737C19.0176 40.0325 25.0857 46.1006 32.5444 46.1006ZM32.5447 21.555C38.6204 21.555 43.5632 26.498 43.5632 32.5737C43.5632 38.6493 38.6202 43.5923 32.5444 43.5923C26.4687 43.5923 21.5257 38.6493 21.5257 32.574C21.5326 26.5052 26.4756 21.562 32.5447 21.555Z"
        fill="black"
      />
      <path
        d="M56.5739 49.6761C55.278 47.3764 52.4165 46.5038 50.0581 47.6878L43.2294 50.9146C42.1523 49.1464 40.2364 48.0255 38.1532 47.9666L31.58 47.7857C30.5966 47.7575 29.6148 47.5041 28.7412 47.053L28.073 46.7067C24.7218 44.9599 20.7544 44.8784 17.3459 46.4616L17.3716 45.5183C17.3808 45.1834 17.2592 44.865 17.0291 44.6217C16.7989 44.3783 16.4875 44.2392 16.1526 44.23L8.94406 44.0318C8.25135 44.012 7.67517 44.5598 7.65634 45.2508L7.22118 61.069C7.2022 61.7604 7.74909 62.3383 8.44017 62.3572L15.6485 62.556L15.6829 62.5562C16.3676 62.5562 16.9184 62.0203 16.9368 61.3365L16.9522 60.7797L18.649 59.8711C19.3086 59.5163 20.0686 59.4332 20.7897 59.637L31.97 62.7754C31.9964 62.783 32.0226 62.7891 32.0537 62.796C32.8817 62.969 33.7303 63.0568 34.5761 63.0568C34.58 63.0568 34.584 63.0568 34.5879 63.0568C36.3724 63.0568 38.1721 62.6636 39.7914 61.9203C39.8459 61.8955 39.8994 61.8661 39.9491 61.8336L56.1629 51.3461C56.7192 50.9862 56.8996 50.2526 56.5739 49.6761ZM32.101 52.6909C31.4128 52.6741 30.8322 53.2187 30.8127 53.9103C30.7943 54.6015 31.3415 55.1793 32.0323 55.1982L42.8385 55.4957L42.8737 55.4958C43.5577 55.4952 44.108 54.9593 44.1264 54.276C44.1354 53.9448 44.1179 53.614 44.0742 53.289L51.1388 49.9507C51.1516 49.945 51.1646 49.9386 51.174 49.9337C51.939 49.5466 52.8494 49.5988 53.5613 50.0418L38.6647 59.6784C36.7547 60.5347 34.6613 60.7672 32.6083 60.3503L21.4684 57.2232C20.1202 56.8421 18.6981 56.9977 17.4644 57.6609L17.032 57.8926L17.2667 49.3586C20.1721 47.5024 23.8536 47.3357 26.9191 48.9333L27.5886 49.2802C28.7952 49.9033 30.1513 50.2535 31.5109 50.2929L38.0844 50.4738C39.6295 50.5184 40.9493 51.5146 41.4305 52.9482L32.101 52.6909ZM14.8303 46.7025L14.4637 60.0146L9.76278 59.8847L10.1289 46.5734L14.8303 46.7025Z"
        fill="black"
      />
      <path
        d="M32.546 18.089C33.2375 18.089 33.8002 17.5265 33.8002 16.835V8.19935C33.8002 7.50787 33.2376 6.94531 32.546 6.94531C31.8546 6.94531 31.292 7.50787 31.292 8.19935V16.8351C31.292 17.5265 31.8546 18.089 32.546 18.089Z"
        fill="black"
      />
      <path
        d="M39.3624 18.0908C40.0539 18.0908 40.6166 17.5282 40.6166 16.8367V12.7464C40.6166 12.0548 40.0539 11.4922 39.3624 11.4922C38.671 11.4922 38.1084 12.0548 38.1084 12.7464V16.8368C38.1084 17.5282 38.6709 18.0908 39.3624 18.0908Z"
        fill="black"
      />
      <path
        d="M25.7291 18.0908C26.4207 18.0908 26.9833 17.5282 26.9833 16.8367V12.7464C26.9833 12.0548 26.4207 11.4922 25.7291 11.4922C25.0379 11.4922 24.4756 12.0548 24.4756 12.7464V16.8368C24.4756 17.5282 25.0379 18.0908 25.7291 18.0908Z"
        fill="black"
      />
    </svg>
  ),
};

export const AFFILIATE_COUNTRY_CODES = ["JP", "KO", "ID", "TC"];
export const SUZU_PLUS_OPTION_MAPPING = {
  AVATAR_SUB_01: ["AVATAR_SUB_PLUS_01", "AVATAR_SUB_01"],
  AVATAR_SUB_10: ["AVATAR_SUB_PLUS_10", "AVATAR_SUB_10"],
  AVATAR_SUB_20: ["AVATAR_SUB_PLUS_20", "AVATAR_SUB_20"],
  AVATAR_SUB_30: ["AVATAR_SUB_PLUS_30", "AVATAR_SUB_30"],
  AVATAR_SUB_40: ["AVATAR_SUB_PLUS_40", "AVATAR_SUB_40"],
  AVATAR_SUB_50: ["AVATAR_SUB_PLUS_50", "AVATAR_SUB_50"],
};
export const AFFILIATE_ACCEPT_LINKS =
  process.env.REACT_APP_NODE_ENV !== "development"
    ? [
        "https://aiavatar.fun",
        "https://store.aiavatar.fun",
        "https://store-jp.aiavatar.fun",
        "https://store-id.aiavatar.fun",
        "https://store-bd.aiavatar.fun",
        "https://store-es.aiavatar.fun",
        "https://suzuverse.com",
        "https://suzuverse.id",
        "https://marketplace.aiavatar.fun",
      ]
    : [
        "https://uat.aiavatar.fun",
        "https://test-store-jp.aiavatar.fun",
        "https://uat-marketplace.aiavatar.fun",

        "https://aiavatar.fun",
        "https://store.aiavatar.fun",
        "https://store-jp.aiavatar.fun",
        "https://store-id.aiavatar.fun",
        "https://store-bd.aiavatar.fun",
        "https://store-es.aiavatar.fun",
        "https://suzuverse.com",
        "https://suzuverse.id",
        "https://marketplace.aiavatar.fun",
      ];

export const AFFILIATE_LINKS = {
  TRACKER: "https://aiavatar.everflowclient.io",
  OFFERS: "https://aiavatar.everflowclient.io/offers",
};

export const ZENDESK_URLS = {
  JA: {
    HELP: "https://a2v-help.zendesk.com/hc/ja",
    PRIVACY_POLICY:
      "https://a2v-help.zendesk.com/hc/ja/articles/45037323005209",
    TERMS_OF_USE:
      "https://a2v-help.zendesk.com/hc/ja/articles/45037021856921",
    REFUND_POLICY:
      "https://a2v-help.zendesk.com/hc/ja/articles/45037644747417",
    AFFILIATE:
      "https://a2v-help.zendesk.com/hc/ja/articles/45037002810649",
    TRACKER:
      "https://a2v-help.zendesk.com/hc/ja/sections/45036787572121",
  },
  KO: {
    HELP: "https://a2v-help.zendesk.com/hc/ko",
    PRIVACY_POLICY:
      "https://a2v-help.zendesk.com/hc/ko/articles/45037323005209",
    TERMS_OF_USE:
      "https://a2v-help.zendesk.com/hc/ko/articles/45037021856921",
    REFUND_POLICY:
      "https://a2v-help.zendesk.com/hc/ko/articles/45037644747417",
    AFFILIATE:
      "https://a2v-help.zendesk.com/hc/ko/articles/45037002810649",
    TRACKER:
      "https://a2v-help.zendesk.com/hc/en-us/sections/45036787572121",
  },
  CN: {
    HELP: "https://a2v-help.zendesk.com/hc/zh-cn",
    PRIVACY_POLICY:
      "https://a2v-help.zendesk.com/hc/zh-cn/articles/45037323005209",
    TERMS_OF_USE:
      "https://a2v-help.zendesk.com/hc/zh-cn/articles/45037021856921",
    AFFILIATE:
      "https://a2v-help.zendesk.com/hc/en-us/articles/45037002810649",
    TRACKER:
      "https://a2v-help.zendesk.com/hc/en-us/sections/45036787572121",
  },
  TC: {
    HELP: "https://a2v-help.zendesk.com/hc/zh-tw",
    PRIVACY_POLICY:
      "https://a2v-help.zendesk.com/hc/zh-tw/articles/45037323005209",
    TERMS_OF_USE:
      "https://a2v-help.zendesk.com/hc/zh-tw/articles/45037021856921",
    AFFILIATE:
      "https://a2v-help.zendesk.com/hc/en-us/articles/45037002810649",
    TRACKER:
      "https://a2v-help.zendesk.com/hc/en-us/sections/45036787572121",
  },
  VI: {
    HELP: "https://a2v-help.zendesk.com/hc/vi",
    PRIVACY_POLICY:
      "https://a2v-help.zendesk.com/hc/vi/articles/45037323005209",
    TERMS_OF_USE:
      "https://a2v-help.zendesk.com/hc/vi/articles/45037021856921",
    AFFILIATE:
      "https://a2v-help.zendesk.com/hc/en-us/articles/45037002810649",
    TRACKER:
      "https://a2v-help.zendesk.com/hc/en-us/sections/45036787572121",
  },
  ID: {
    HELP: "https://a2v-help.zendesk.com/hc/id",
    PRIVACY_POLICY:
      "https://a2v-help.zendesk.com/hc/id/articles/45037323005209",
    TERMS_OF_USE:
      "https://a2v-help.zendesk.com/hc/id/articles/45037021856921",
    AFFILIATE:
      "https://a2v-help.zendesk.com/hc/en-us/articles/45037002810649",
    TRACKER:
      "https://a2v-help.zendesk.com/hc/en-us/sections/45036787572121",
  },
  PT: {
    HELP: "https://a2v-help.zendesk.com/hc/pt",
    PRIVACY_POLICY:
      "https://a2v-help.zendesk.com/hc/pt/articles/45037323005209",
    TERMS_OF_USE:
      "https://a2v-help.zendesk.com/hc/pt/articles/45037021856921",
    AFFILIATE:
      "https://a2v-help.zendesk.com/hc/en-us/articles/45037002810649",
    TRACKER:
      "https://a2v-help.zendesk.com/hc/pt/sections/45036787572121",
  },
  ES: {
    HELP: "https://a2v-help.zendesk.com/hc/es",
    PRIVACY_POLICY:
      "https://a2v-help.zendesk.com/hc/es/articles/45037323005209",
    TERMS_OF_USE:
      "https://a2v-help.zendesk.com/hc/es/articles/45037021856921",
    AFFILIATE:
      "https://a2v-help.zendesk.com/hc/en-us/articles/45037002810649",
    TRACKER:
      "https://a2v-help.zendesk.com/hc/en-us/sections/45036787572121",
  },
  EN: {
    HELP: "https://a2v-help.zendesk.com/hc/en-us",
    PRIVACY_POLICY:
      "https://a2v-help.zendesk.com/hc/en-us/articles/45037323005209",
    TERMS_OF_USE:
      "https://a2v-help.zendesk.com/hc/en-us/articles/45037021856921",
    REFUND_POLICY:
      "https://a2v-help.zendesk.com/hc/en-us/articles/44720109812121",
    AFFILIATE:
      "https://a2v-help.zendesk.com/hc/en-us/articles/45037002810649",
    TRACKER:
      "https://a2v-help.zendesk.com/hc/en-us/sections/45036787572121",
  },
};

export const LINKTR_URLS = {
  EN: "https://linktr.ee/aiavatar_official",
  JA: "https://linktr.ee/aiavatar_official",
  KO: "https://linktr.ee/aiavatar_official",
  CN: "https://linktr.ee/aiavatar_official",
  TC: "https://linktr.ee/aiavatar_official",
  VI: "https://linktr.ee/aiavatar_official",
  ID: "https://linktr.ee/aiavatar_official",
  PT: "https://linktr.ee/aiavatar_official",
  ES: "https://linktr.ee/aiavatar_official",
};
